(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/cylinder-wrapper/assets/product-cylinder-wrapper.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/cylinder-wrapper/assets/product-cylinder-wrapper.js');
'use strict';

const {
  ProductCylinder
} = svs.tb_ui_react.cylinder_wrapper;
const ProductCylinderWrapper = _ref => {
  let {
    products,
    isDefault
  } = _ref;
  return React.createElement("div", {
    className: "u-position-absolute w100 login-react-overflow-hidden login-react-vh ".concat(isDefault ? 'cylinder-default' : '')
  }, products.map((product, index) =>
  React.createElement(ProductCylinder, {
    className: product,
    game: product,
    isProduct: !isDefault,
    key: index,
    position: index
  })));
};
svs.tb_ui_react.cylinder_wrapper.ProductCylinderWrapper = ProductCylinderWrapper;

 })(window);